import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import gql from 'graphql-tag';
import { ToastService } from 'ng-uikit-pro-standard';
import { DocumentoDetalleService } from 'src/app/services/documento-detalle.service';
import { DocumentoService } from 'src/app/services/documento.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { MotivoDevolucionService } from 'src/app/services/motivo-devolucion.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalObservacionesComponent } from '../../common/modal-observaciones/modal-observaciones.component';

@Component({
  selector: 'app-nota-debito-detalles',
  templateUrl: './nota-debito-detalles.component.html',
  styleUrls: ['./nota-debito-detalles.component.scss'],
  providers: [SecurityService],
})
export class NotaDebitoDetallesComponent implements OnInit {
  // Modales
  @ViewChild(ModalObservacionesComponent, { static: true }) modalObservaciones: ModalObservacionesComponent;

  // Data &  Tmp
  private rutEmpresa: Number;
  private sucursalEmpresa: Number;
  dataCabecera: any;
  optionsMotivoGeneral: Array<any> = [];
  optionsMotivoEspecifico: Array<any> = [];
  optionsFormatoProductoLibre: Array<any> = [{ value: 'UNID', label: 'Unidad' }];
  totales: any = null;
  additionalHeaderInfo: any = null;
  observaciones: string = '';

  // Form
  formProductoLibre: FormGroup;
  formGlosa: FormGroup;
  formMotivoGeneral: FormGroup;

  // Utils
  private log: any;

  constructor(
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private motivoDevolucionService: MotivoDevolucionService,
    private documentoService: DocumentoService,
    private documentoDetalleService: DocumentoDetalleService,
    private clog: ConsoleService,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService
  ) {
    this.log = this.clog.log('NOTA-DEBITO-DETALLE');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());

    this.loadMotivoDevolucionGeneral();

    this.createForms();
  }

  createForms() {
    this.formProductoLibre = this.fb.group({
      codigo: ['', [Validators.min(-1)]],
      descripcion: ['', [Validators.required]],
      cantidad: [1, [Validators.required, Validators.min(1)]],
      formato: ['UNID', [Validators.required]],
      precioUnitario: [0, [Validators.required, Validators.min(1)]],
    });
    this.formGlosa = this.fb.group({
      glosa: [null, [Validators.required, Validators.minLength(1), Validators.maxLength(300)]],
    });
    this.formMotivoGeneral = this.fb.group({
      motivo: [0, [Validators.required]],
    });
  }

  private loadMotivoDevolucionGeneral() {
    // Tipos documentos
    this.motivoDevolucionService.GetMotivoDevolucionGeneral(this.rutEmpresa, this.sucursalEmpresa, ({ respuesta }) => {
      const { registros } = respuesta;
      this.optionsMotivoGeneral = registros.map((tipo) => ({ value: tipo.codigo, label: tipo.nombre, ...tipo }));
    });
  }

  get detalles() {
    // this.log('getDetalles this.dataCabecera', this.dataCabecera)
    if (!this.dataCabecera || !this.dataCabecera.cabecera || !this.dataCabecera.cabecera.additionalInfo || !this.dataCabecera.detalleDocumento) return [];
    const { esCorreccionDeMonto, tipoCorreccionMonto, tipoNotaDebito } = this.dataCabecera.cabecera.additionalInfo;
    // if (tipoCorreccionMonto === 20 && tipoNotaDebito === 2) {
    if (esCorreccionDeMonto) {
      return this.dataCabecera.detalleDocumento.filter((doc) => doc.es_correcion_monto);
    }
    if (this.dataCabecera.cabecera.tipo_ncnd_codigo === 4) {
      return this.dataCabecera.detalleDocumento.filter((doc) => doc.es_correcion_monto);
    }
    return this.dataCabecera.detalleDocumento.filter((doc) => !doc.es_correcion_monto);
  }

  handleCabeceraChange(dataCabecera) {
    this.dataCabecera = dataCabecera;
    // this.log('Data cabecera recibida', this.dataCabecera.cabecera.additionalInfo, this.dataCabecera, JSON.stringify(this.dataCabecera.cabecera))
    this.log('Data cabecera recibida', this.dataCabecera);

    this.totales = null;
    this.formGlosa.get('glosa').setValue('');

    // this.resetMostrar()

    if (!this.dataCabecera) {
      this.additionalHeaderInfo = null;
      return;
    }

    this.additionalHeaderInfo = dataCabecera.cabecera.additionalInfo;

    // if (dataCabecera.cabecera.additionalInfo.tipoCorreccionMonto === 20)
    //   this.dataCabecera.detalleDocumento = []

    this.loadMotivoDevolucionEspecifico(this.dataCabecera.cabecera.rut_emisor);

    if (this.additionalHeaderInfo.showTotales) this.ObtenerTotales();
  }

  // private resetMostrar() {
  //   this.showTabla = false
  //   this.showTotales = false
  //   this.showProductoLibre = false
  //   this.showMotivoGeneral = false
  //   this.showGlosa = false
  // }

  private loadMotivoDevolucionEspecifico(rut_emisor) {
    // Tipos documentos
    this.motivoDevolucionService.GetMotivoDevolucionEspecifico(rut_emisor, this.sucursalEmpresa, ({ respuesta }) => {
      const { registros } = respuesta;
      this.optionsMotivoEspecifico = registros.map((tipo) => ({ value: tipo.codigo, label: tipo.descripcion, ...tipo }));
    });
  }

  ObtenerTotales() {
    this.FetchObtenerTotales(({ mensajes, respuesta }) => {
      const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      this.totales = respuesta;
    });
  }

  //Obtener totales de documento
  FetchObtenerTotales(callback: Function) {
    this.log('FetchObtenerTotales this.dataCabecera', this.dataCabecera);
    const { esCorreccionDeMonto, tipoNotaDebito } = this.dataCabecera.cabecera.additionalInfo;
    const inputParams = {
      entidadDTO: {
        cabecera: {
          rut_emisor: this.rutEmpresa,
          sucursal_codigo: this.sucursalEmpresa,
          cliente_proveedor_rut: this.dataCabecera.cliente_proveedor_rut,
          direccion_codigo: this.dataCabecera.direccion_codigo,
          // lista_precio_codigo: 1,
          es_correcion_monto: esCorreccionDeMonto,
          es_nd: true, // Si es Nota de Debito
          tipo_ncnd_codigo: tipoNotaDebito,
        },
        descuentosGlobales: this.dataCabecera.descuentosGlobales,
        detalleDocumento: this.cleanDetalledocumento(this.dataCabecera.detalleDocumento),
      },
    };

    this.log('inputParams totales', JSON.stringify(inputParams));

    this.documentoService.ObtenerTotalesDocumento(inputParams, callback);
  }

  private cleanDetalledocumento(detalleDocumento) {
    // let _detalledocumento = [...detalleDocumento]
    let _detalledocumento = [];
    detalleDocumento.forEach((val) => _detalledocumento.push(Object.assign({}, val)));
    _detalledocumento.map((p) => {
      delete p.additionalInfo;
      delete p.__typename;
      if (this.dataCabecera.cabecera.tipo_ncnd_codigo === 4 && this.dataCabecera.cabecera.tipo_dte_codigo === 61) {
        if (p.es_correcion_monto) {
          p.es_correcion_monto = false;
        }
      }
      p.aplicacion_descuento = 0;
      p.aplicacion_descuento_tope = 0;
      p.aplicacion_recargo = 0;
      p.aplicacion_imp_adic = 0;
      if (p.atributos)
        p.atributos.forEach((attr) => {
          delete attr.__typename;
        });
      if (p.listaProductoFormato)
        p.listaProductoFormato.forEach((from) => {
          delete from.__typename;
        });
    });
    return _detalledocumento;
  }

  //Query para validar detalle
  ValidarDetalle(detalle) {
    const inputParams = {
      entidad_detalleDTO: {
        rut_emisor: detalle.rut_emisor,
        folio: detalle.folio,
        tipo_dte_codigo: detalle.tipo_dte_codigo,
        nro_linea: detalle.nro_linea,
        producto_codigo: detalle.producto_codigo,
        sku: detalle.sku,
        formato_codigo: detalle.formato_codigo,
        descripcion_producto: detalle.descripcion_producto,
        cantidad: Number(detalle.cantidad),
        precio_neto: detalle.precio_neto,
        precio_unitario: detalle.precio_unitario,
        monto_total_neto: detalle.monto_total_neto,
        monto_total: detalle.monto_total,
        es_producto_libre: detalle.es_producto_libre,
        es_facturable: detalle.es_facturable,
        gasto_codigo: detalle.gasto_codigo,
        equivalencia_producto_id: detalle.equivalencia_producto_id,
        motivo_devolucion_especifico_codigo: detalle.motivo_devolucion_especifico_codigo,
        es_correcion_monto: detalle.es_correcion_monto,
        atributos: detalle.atributos,
      },
    };

    this.documentoDetalleService.ValidarDetalleNotaDebito(inputParams, ({ mensajes, respuesta }) => {
      const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      this.toastrService.success('Registro editado con éxito');
    });
  }

  //Nota de Débito agregar correcion de monto
  AgregarCoreccionMonto() {
    const valid = this.formValidatorsService.validate(this.formProductoLibre);
    if (!valid) {
      this.toastrService.warning('Complete los campos requeridos');
      return;
    }

    const { codigo, formato, descripcion, cantidad, precioUnitario } = this.formProductoLibre.value;
    const formatoLibre = this.optionsFormatoProductoLibre.find((opt) => opt.value === formato);
    const formatoNombre = formatoLibre ? formatoLibre.label : formato;
    const inputParams = {
      entidad_detalleDTO: {
        tipo_dte_codigo: 56, // FIJO
        producto_codigo: codigo ? codigo : 0,
        sku: codigo ? codigo : 0,
        formato_codigo: formato,
        formato_nombre: formatoNombre,
        descripcion_producto: descripcion,
        cantidad: cantidad,
        precio_unitario: precioUnitario,
        es_correcion_monto: true, // TODO: Siempre en 0?
      },
      entidadDTO: {
        cabecera: {
          rut_emisor: this.rutEmpresa,
          sucursal_codigo: this.sucursalEmpresa,
          cliente_proveedor_rut: this.dataCabecera.cabecera.cliente_proveedor_rut,
          direccion_codigo: this.dataCabecera.cabecera.direccion_codigo,
        },
        descuentosGlobales: [], //this.dataCabecera.descuentosGlobales,
        detalleDocumento: this.cleanDetalledocumento(this.dataCabecera.detalleDocumento),
      },
    };

    this.log('input params AgregarCoreccionMonto', JSON.stringify(inputParams));

    this.documentoDetalleService.AgregarDetalleCorrecionMonto(inputParams, ({ mensajes, respuesta }) => {
      const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      this.toastrService.success('Registro agregado');

      respuesta.registros.map((detalle) => {
        delete detalle.__typename;
        if (detalle.atributos)
          detalle.atributos.map((attr) => {
            delete attr.__typename;
          });
        detalle.additionalInfo = {
          editing: false,
          checked: false,
        };
      });

      this.dataCabecera.detalleDocumento = respuesta.registros;

      this.ObtenerTotales();

      this.resetFormProductoLibre();
    });
  }

  resetFormProductoLibre() {
    this.formProductoLibre.reset();
    this.formProductoLibre.markAsPristine();
    this.formProductoLibre.markAsUntouched();

    this.formProductoLibre.get('codigo').setValue('');
    this.formProductoLibre.get('descripcion').setValue('');
    this.formProductoLibre.get('cantidad').setValue(1);
    this.formProductoLibre.get('formato').setValue('UNID');
    this.formProductoLibre.get('precioUnitario').setValue(0);
  }

  checkDetalleProductoLibre(detalle) {
    detalle.additionalInfo.checked = !detalle.additionalInfo.checked;
  }

  deleteDetallesCorrecionMonto() {
    this.dataCabecera.detalleDocumento = this.dataCabecera.detalleDocumento.filter((detalle) => !detalle.es_correcion_monto || (detalle.es_correcion_monto && !detalle.additionalInfo.checked));
    this.ObtenerTotales();
  }

  showModalObservaciones() {
    this.modalObservaciones.show();
  }

  // get detallesResumidos() {
  //   return this.dataCabecera.detalleDocumento.map(p => ({
  //     nro_linea: p.nro_linea,
  //     cantidad: p.cantidad,
  //     motivo_devolucion_especifico_codigo: p.motivo_devolucion_especifico_codigo
  //   }))
  // }

  saveObservaciones({ data: observaciones }) {
    this.observaciones = observaciones;
  }

  getDetailsData() {
    return {
      observaciones: this.observaciones,
      glosa_administrativa: this.formGlosa.get('glosa').value,
      motivoGeneral: this.formMotivoGeneral.get('motivo').value,
      detalleDocumento: this.detalles, // this.dataCabecera.detalleDocumento
    };
  }

  cleanData() {
    this.dataCabecera = null;
    // this.optionsMotivoGeneral = [];
    this.optionsMotivoEspecifico = [];
    this.optionsFormatoProductoLibre = [{ value: 'UNID', label: 'Unidad' }];
    this.totales = null;
    this.additionalHeaderInfo = null;
    this.observaciones = '';
    this.modalObservaciones.cleanAll();

    // Forms
    this.formProductoLibre.reset();
    this.formProductoLibre.markAsUntouched();
    this.formProductoLibre.markAsPristine();

    this.formGlosa.reset();
    this.formGlosa.markAsUntouched();
    this.formGlosa.markAsPristine();

    this.formMotivoGeneral.reset();
    this.formMotivoGeneral.markAsUntouched();
    this.formMotivoGeneral.markAsPristine();

    this.resetFormProductoLibre();
    this.formGlosa.get('glosa').setValue(null);
    this.formMotivoGeneral.get('motivo').setValue(0);
  }
}
